var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBodylimit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.1505,
    cy: 8.71792,
    r: 4.61538,
    fill: "#606A96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99609 20.5127C6.99609 17.1141 9.75127 14.3589 13.1499 14.3589C16.5486 14.3589 19.3038 17.1141 19.3038 20.5127V27.6922H6.99609V20.5127Z",
    fill: "#606A96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99609 27.6924H12.1243V34.8719C12.1243 35.4383 11.6651 35.8975 11.0987 35.8975H8.02174C7.45529 35.8975 6.99609 35.4383 6.99609 34.8719V27.6924Z",
    fill: "#92A0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1758 27.6924H19.304V34.8719C19.304 35.4383 18.8448 35.8975 18.2783 35.8975H15.2014C14.635 35.8975 14.1758 35.4383 14.1758 34.8719V27.6924Z",
    fill: "#92A0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 13.5C31.0899 13.5 34 16.4101 34 20C34 23.5899 31.0899 26.5 27.5 26.5C23.9101 26.5 21 23.5899 21 20C21 16.4101 23.9101 13.5 27.5 13.5ZM24.8359 22.9824C25.5434 23.6148 26.4765 24 27.5 24C29.7091 24 31.5 22.2091 31.5 20C31.5 19.7202 31.4707 19.4472 31.416 19.1836L24.8359 22.9824ZM27.5 16C25.2909 16 23.5 17.7909 23.5 20C23.5 20.2801 23.5282 20.5535 23.583 20.8174L30.165 17.0176C29.4575 16.3849 28.5238 16 27.5 16Z",
    fill: "#FF5959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBodylimit);
export default __webpack_public_path__ + "static/media/ic_bodylimit.e6ab0122f4c787287c84a26c33e76f7f.svg";
export { ForwardRef as ReactComponent };